<template>
  <div class="storeList">
    <div class="header">
        <div class="divs">
          <div class="fz18">{{ $t('shopList.list') }}</div>
        </div>
      </div>
    <div class="main">
      <vxe-table
        :loading="loading"
        border
        show-header-overflow
        show-overflow
        align="center"
        :row-config="{ isHover: true }"
        :data="tableData"
      >
        <vxe-column field="tenantName" :title="$t('shopList.company')"></vxe-column>
        <vxe-column field="status" :title="$t('shopList.status')"></vxe-column>
        <vxe-column field="shopName" :title="$t('shopList.Store')"></vxe-column>
        <vxe-column field="preferred" :title="$t('shopList.defaultStore')">
          <template #default="{ row }">
            <span
              class="shouli"
              @click="setDefault(row.tenantId)"
              v-has="'WSS-3000-edit'"
              >{{ row.settable ? $t('shopList.set') : '' }}</span
            >
            <span>{{ row.preferred ? $t('shopList.default') : '' }} </span>
          </template>
        </vxe-column>
      </vxe-table>
    </div>
  </div>
</template>

<script>
import {
  findShop,
  getDefault
} from '../../../api/myweb/shopmanagement/storelist'
export default {
  components: {},
  data() {
    return {
      loading: false,
      tableData: []
    }
  },
  created() {
    this.getcompanyList()
  },
  methods: {
    async getcompanyList() {
      this.loading = true
      const res = await findShop()
      // console.log(res)
      if (res.status) {
        this.tableData = res.data
      }
      this.loading = false
    },
    async setDefault(id) {
      const res = await getDefault({ tenantId: id })
      // console.log(res)
      if (res.status) {
        this.getcompanyList()
      }
    }
  },
  computed: {},
  watch: {}
}
</script>
<style lang='less' scoped>
.header {
  // padding-bottom: 8px;
  // border-bottom: 2px solid #ccc;
  width: 100%;
  height: 60px;
  background: #FFFFFF;
  // box-shadow:2px 2px 10px 3px rgba(104, 104, 104, 0.1);
  box-shadow: 0px 6px 10px rgba(104, 104, 104, 0.1);
  opacity: 1;
  border-radius: 0px;
  padding-left: 19px;
  padding-top: 22px;

  .divs {
    width: 380px;
    display: flex;
    justify-content: space-between;
    font-size: 16px;
    font-weight: bold;
    color: #505050;
    .fz18{
      line-height: 16px;
    }
  }
}
.main {
  margin-top: 10px;
  height: 100%;
  min-height: 750px;
  background: #FFFFFF;
  // box-shadow: 2px 2px 10px 3px rgba(104, 104, 104, 0.1);
  box-shadow: 0px 6px 10px rgba(104, 104, 104, 0.1);
  padding: 20px ;
  .shouli {
    color: #2d8cf0;
    text-decoration: none;
    cursor: pointer;
  }
}
</style>